<template>
  <v-form @submit.prevent="recoverUserPassword(user.email)">
    <label class="input-label">Adres e-mail konta:</label>
    <v-text-field
      v-model="user.email"
      height="40"
      outlined
      dense
      readonly
    />

    <v-btn
      class="custom-submit-button mt-4"
      color="primary"
      type="submit"
    >
      Resetuj hasło
    </v-btn>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions('users', ['recoverUserPassword']),
  },
};
</script>
